export const STATUS_EVENT_SIGNAL_LANGUAGE_COLUMN_PREFIX = 'lang:';
export const STATUS_EVENT_MAX_FILE_SIZE_ALLOWED = 100 * 1024; //100KB
export const BIT_PARSING_MAX_ALLOWED_ERROR_CODES = 64;
export const VALUE_PARSING_MAX_ALLOWED_ERROR_CODES = 500;
export const COLUMNS_SEPARATOR = ',';